<template><div><component-combinator component-name="DtValidationMessages" /><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Validation messages are typically paired with an input element. They are currently built in to some of our shared input components such as <code v-pre>dt-input</code> and <code v-pre>dt-radio-group</code>.</p>
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="positive" tabindex="-1" class="d-docsite--header-3">Positive <a class="header-anchor d-link d-docsite--link d-link" href="#positive" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-validation-messages
  id=&quot;sample--02&quot;
  :validationMessages=&#39;[{&quot;message&quot;:&quot;Positive validation message&quot;,&quot;type&quot;:&quot;positive&quot;}]&#39;
/&gt;'>
<dt-validation-messages
  id="sample--02"
  :validationMessages='[{"message":"Positive validation message","type":"positive"}]'
/>
</code-example>
<h3 id="critical" tabindex="-1" class="d-docsite--header-3">Critical <a class="header-anchor d-link d-docsite--link d-link" href="#critical" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-validation-messages
  id=&quot;sample--03&quot;
  :validationMessages=&#39;[{&quot;message&quot;:&quot;Critical validation message&quot;,&quot;type&quot;:&quot;critical&quot;}]&#39;
/&gt;'>
<dt-validation-messages
  id="sample--03"
  :validationMessages='[{"message":"Critical validation message","type":"critical"}]'
/>
</code-example>
<h3 id="warning" tabindex="-1" class="d-docsite--header-3">Warning <a class="header-anchor d-link d-docsite--link d-link" href="#warning" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-validation-messages
  id=&quot;sample--04&quot;
  :validationMessages=&#39;[{&quot;message&quot;:&quot;Warning validation message&quot;,&quot;type&quot;:&quot;warning&quot;}]&#39;
/&gt;'>
<dt-validation-messages
  id="sample--04"
  :validationMessages='[{"message":"Warning validation message","type":"warning"}]'
/>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="validationmessages" /></div></template>


